namespace GeniuzPOS.QRreport {
    export interface QRywcSpecForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
    }

    export class QRywcSpecForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecForm.init)  {
                QRywcSpecForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(QRywcSpecForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2
                ]);
            }
        }
    }
}
